export const API = process.env.REACT_APP_BACKEND_API_ROOT;